import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface IndustryProps {
  open: boolean;
  handleClose: () => void;
}

function CreateIndustryModal({
  open,
  handleClose,
}: IndustryProps) {

  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const dispatch = useDispatch();

  const [industryName, SetIndustryName] = useState(null);
  const [loading, setLoading] = useState(false);


  const CreateNewIndustry = async() => {
    const data = {
      industry_name: industryName,
    };
    try{
      setIsLoading(true);
      setLoading(true);
      if (oauthTokenHeader) {
        await MetaEntitiesEndPointLogic.createMetaIndustry(oauthTokenHeader, data);
      }else{
        throw new Error("User doesn't have permissions to create new themes");
      }
      if(oauthTokenHeader){
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaIndustry(oauthTokenHeader,dispatch);
      }
    }catch(error){
      console.error(error, "error");
    }finally{
      setIsLoading(false);
      setLoading(false);    
      handleClose();
      SetIndustryName(null)
      await MetaEntitiesEndPointLogic.getMetaIndustry(oauthTokenHeader,dispatch);
    }
  }

  const handleCancel = () => {
    handleClose();
    SetIndustryName(null);
  }

  return (
    <>
    {loading ? <SimpleBackdrop /> : (
      <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
      <Paper sx={{ padding: "16px 24px 20px 24px" }}>
        <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
        Create New Industry
        </DialogTitle>
        <Typography sx={{mb:1}}>Details</Typography>
        <Grid container mt={0} columnSpacing={3}>
          <Grid item xs={12}>
            <TextField
              value = {industryName}
              onChange={(e:any) => SetIndustryName(e.target.value)}
              id="outlined-multiline-flexible"
              label="Industry Name *" // Set your label here
              placeholder="Enter unique Industry Name" // Set your placeholder here
              color="secondary"
              size="small"
              fullWidth
            />
          </Grid>
        </Grid>
        <Typography
          sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
        >
          This is a mandatory field.
        </Typography>

        <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
          <Button color="secondary" onClick={handleCancel} sx={{mr:1}}>
            CANCEL
          </Button>
          <Button variant="contained" color="secondary" disabled={!industryName} 
          data-tracker="237"
          onClick={CreateNewIndustry}>
          Create <DoneIcon sx={{ml:1}} />
          </Button>
        </Stack>
      </Paper>
      </Dialog>
    )}
    </>
  );
}

export default CreateIndustryModal;
